import { useEffect, useState } from 'react';
import axios from 'axios';

const apiUrl = 'https://elcobradorleague.com/api';

export const useLeaderboard = (idleague) => {
  const [divisions, setDivisions] = useState([]);

  useEffect(() => {
    if (!idleague) return;

    const controller = new AbortController();

    axios.get(
      `${apiUrl}/api.php?endpoint=leaderboard&idleague=${idleague}`,
      {
        headers: {
          'X-API-TOKEN': process.env.REACT_APP_API_TOKEN
        },
        signal: controller.signal
      }
    )
    .then(res => {
      const data = res.data;

      if (Array.isArray(data)) {
        const grouped = data.reduce((acc, row) => {
          if (!acc[row.division]) {
            acc[row.division] = {
              division: row.divisionname,
              players: []
            };
          }
          acc[row.division].players.push(row);
          return acc;
        }, {});
        setDivisions(Object.values(grouped));
      } else {
        setDivisions([]);
      }
    })
    .catch(() => setDivisions([]));

    return () => controller.abort();
  }, [idleague]);

  return { divisions };
};
